// extracted by mini-css-extract-plugin
export default {"fabVisibility":"Fab_fabVisibility__aRAnz"};